import React, { useCallback } from 'react';

import { toTitle } from '../../base2/utils';
import { Input } from '../basic-inputs';

interface SelectedBeneficiaryProps {
  person: any;
  handleRemoveBeneficiary?: ((person: any) => void) | null;
}

export function SelectedBeneficiary({ person, handleRemoveBeneficiary = null }: SelectedBeneficiaryProps) {
  const fullName = `${person.firstName} ${person.lastName}`;

  const handleClick = useCallback(() => {
    if (handleRemoveBeneficiary) {
      handleRemoveBeneficiary(person);
    }
  }, [ handleRemoveBeneficiary, person ]);

  return (
    <div className="selected-beneficiary">
      <div className="person-select-text-container">
        <span className="person-select-text">{toTitle(fullName)}</span>
        <span className="person-select-subtext">
          {person.contactEmail}
        </span>
      </div>
      <Input 
        className="beneficiary-percent"
        name={`percent-${person.id}`}
        placeholder="%"
        type="number"
      />
      <span className="material-symbols-outlined" onClick={handleClick}>
        close
      </span>
    </div>
  );
}
